// 高德地图配置
export const AMAP_CONFIG = {
  // 请替换为您的高德地图API Key
  // 申请地址：https://lbs.amap.com/api/javascript-api/guide/abc/prepare
  // 临时测试Key（可能有限制，建议申请自己的Key）
  key: 'feba79ca560371b3e49dcb549c306ec7',
  version: '2.0',
  plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.Geocoder']
};

// 是否启用地图功能（当API Key未配置时可以禁用）
export const MAP_ENABLED = AMAP_CONFIG.key !== 'your-amap-api-key-here';

// 默认坐标（北京通州区金融街武夷融御4号楼901）
export const DEFAULT_COORDINATES = {
  longitude: '116.397428',
  latitude: '39.90923'
};
